<template>
  <div class="max-w-full overflow-hidden">
    <div class="trending-posts-two-grid">
      <TrendingItem
        v-for="(post, index) in posts"
        :key="post.id"
        :post="post"
        :postIndex="index"
      />
    </div>
  </div>
</template>
<script>
import TrendingItem from "@/templates/post-list/TrendingItem.vue";

export default {
  name: "TrendingPostsTwoGrid",
  props: {
    posts: Array,
  },
  components: { TrendingItem },
};
</script>
<style>
.trending-posts-two-grid {
  @apply flex flex-wrap lg:-mx-10 md:-mx-6;
}
.trending-posts-two-grid article.trending {
  @apply w-full md:w-1/2 mb-10 flex lg:px-10 md:px-6;
}
.trending-posts-two-grid .index {
  @apply text-yka-blue text-center text-4xl w-10 relative mr-4 opacity-50;
}
.trending-posts-two-grid .author-name {
  @apply font-normal;
}
.trending-posts-two-grid .title {
  @apply text-base text-lg font-bold text-black tracking-tight leading-tight mb-4;
}
.trending-posts-two-grid article.trending .author-avatar {
  @apply h-8 w-8;
}
.trending-posts-two-grid article.trending .author-avatar-parent {
  @apply mr-2;
}
.trending-posts-two-grid article.trending .meta .item {
  @apply mr-1;
}

.right-sidebar .trending-posts-two-grid {
  @apply flex-none;
}
.right-sidebar .trending-posts-two-grid .trending {
  @apply w-full mb-0;
}
.right-sidebar .trending-posts-two-grid .index {
  @apply mr-2;
}
.right-sidebar .trending-posts-two-grid .trending .author-avatar-parent {
  @apply hidden;
}
.right-sidebar .trending-posts-two-grid .author-name {
  @apply text-xs text-mid-gray;
}
.right-sidebar .trending-posts-two-grid .meta {
  @apply text-mid-gray;
}
.right-sidebar .trending-posts-two-grid .title {
  @apply mb-0 text-sm font-medium;
}
</style>
